import * as R from 'ramda'
import React, { useState } from 'react'
import { Input, Image, Form } from 'semantic-ui-react'
import { Card, CardDescription, CardGroup } from 'components/Card'
import { useScrollPosition } from 'hooks/useScrollPosition'

export default function IntegrationForm({ items, selectedItems, setSelectItems, integrationType }) {
  const [integrations, setIntegrations] = useState(items)
  const { scrollRef, isScrollable, isAtBottom } = useScrollPosition()

  function resizeImageURL(imageUrl) {
    const defaultImage = 'https://react.semantic-ui.com/images/wireframe/image.png'
    if (!imageUrl || imageUrl == 'null') {
      return defaultImage
    }

    const url = new URL(imageUrl)
    const params = new URLSearchParams(url.search)
    params.append('size', 'x64')
    return `${url.origin}${url.pathname}?${params.toString()}`
  }

  function handleSearchChange(_, { value }) {
    const matchedIntegration = items.filter((integration) =>
      R.contains(R.toLower(value), R.toLower(integration.name))
    )
    setIntegrations(matchedIntegration)
  }

  function handleSelectItems(isActive, item) {
    if (isActive) {
      item.type = integrationType
      setSelectItems([...selectedItems, item])
    } else {
      const newSelectedItem = selectedItems.filter((obj) => {
        return obj.id != item.id
      })
      setSelectItems(newSelectedItem)
    }
  }

  const displaySearchInput = items?.length >= 10

  return (
    <Form.Field>
      {displaySearchInput && (
        <Input
          icon="far fa-magnifying-glass"
          placeholder="Search integrations"
          iconPosition="left"
          fluid
          onChange={handleSearchChange}
        />
      )}

      <div
        ref={scrollRef}
        className="onboarding-integration-scroll px-0.5 overflow-x-hidden overflow-y-auto"
      >
        <CardGroup itemsPerRow={2} doubling className="pt-5">
          {integrations?.map((item) => {
            const isSelected = selectedItems.some((selected) => selected.id === item.id)
            return (
              <Card
                link
                key={`${item.name}-card`}
                active={isSelected}
                onClick={() => handleSelectItems(!isSelected, item)}
              >
                <CardDescription
                  key={`${item.name}-card-content`}
                  className="!flex !flex-row items-center relative justify-center md:!justify-start p-2"
                >
                  <Image key={`${item.name}-image`} src={resizeImageURL(item.image)} width="24px" />
                  <span
                    key={`${item.name}`}
                    className="pl-3 overflow-hidden font-bold text-black whitespace-nowrap ellipsis"
                  >
                    {item.name}
                  </span>
                </CardDescription>
              </Card>
            )
          })}
        </CardGroup>
      </div>
      {isScrollable && !isAtBottom && (
        <div className="absolute bottom-0 z-10 flex justify-center w-full py-8 translate-y-1/2 pointer-events-none bg-gradient-to-b from-transparent to-white" />
      )}
    </Form.Field>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntegrationForm/index.js